export const NO_OPTIONS_MSG="該当するデータはありません。";